export enum SignatoryStatusEnum {
	STATUT_EN_ATTENTE = 'STATUT_EN_ATTENTE',
	STATUT_EN_COURS = 'STATUT_EN_COURS',
	STATUT_ACCEDE = 'STATUT_ACCEDE',
	STATUT_CODE_ENVOYE = 'STATUT_CODE_ENVOYE',
	STATUT_SIGNE = 'STATUT_SIGNE',
	STATUT_ATTENTE_DOCS = 'STATUT_ATTENTE_DOCS',
	STATUT_ATTENTE_VALIDATION = 'STATUT_ATTENTE_VALIDATION',
	STATUT_ANNULE = 'STATUT_ANNULE',
	STATUT_ERREUR = 'STATUT_ERREUR'
}
